import { Chip, Dropdown, IconButton, Menu, MenuButton, MenuItem, Table } from '@mui/joy'
import React from 'react'
import MoreVert from '@mui/icons-material/MoreVert';
import { url } from '../../../../../../Script/Session';
import ReportOutlinedIcon from '@mui/icons-material/ReportOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
function DateienViewer({ data, editperms, subkath }) {

    return (
        <Table>
            <thead>
                <tr>
                    <th>Dateiname</th>
                    <th>Typ</th>
                    <th>Endung</th>
                    <th>Größe</th>
                    <th>Status</th>
                    <th>Sonstiges</th>
                </tr>
            </thead>
            <tbody>
                {data && data.pflichtdateien.map(item => (
                    <tr key={item.id}>
                        <td>{item.anzeigename}</td>
                        <td>{item.type}</td>
                        <td>.{item.name.split(".")[1]}</td>
                        <td>{item.size.toString().split(".")[0]} Kilobyte</td>
                        <td>{!item.mussgeprüftwerden && (
                            <Chip startDecorator={<CheckCircleOutlineOutlinedIcon/>} variant='soft' sx={{bgcolor: "#c8e6c9"}}>
                                Geprüft
                            </Chip>
                        )}
                        {item.mussgeprüftwerden && (
                            <Chip startDecorator={<ReportOutlinedIcon/>} variant='soft' sx={{bgcolor: "#ffcdd2"}}>
                                Muss Geprüft werden
                            </Chip>
                        )}
                        </td>
                        <td>
                            <Dropdown>
                                <MenuButton
                                    slots={{ root: IconButton }}
                                    slotProps={{ root: { variant: 'outlined', color: 'neutral' } }}
                                >
                                    <MoreVert />
                                </MenuButton>
                                <Menu>
                                    <MenuItem onClick={() => window.open(
                                        `${url}/api/filedownload/${item.id}/${item.anzeigename}.${item.name.split(".").pop()}`,
                                        "_blank",
                                        "noopener,noreferrer"
                                    )}>Herunterladen</MenuItem>
                                    <MenuItem
                                    onClick={() => window.open(
                                        `${window.location.origin}/file_prüfer/${item.id}/${item.anzeigename}.${item.name.split(".").pop()}/${subkath}/${editperms}/${item.type}/${item.stand}`,
                                        "_blank",
                                        "noopener,noreferrer"
                                    )}
                                    
                                    >Prüfungen</MenuItem>
                                </Menu>
                            </Dropdown></td>
                    </tr>
                ))}
            </tbody>
        </Table>
    )
}

export default DateienViewer
